'use client';

import cx from 'classnames';
import { ChangeEventHandler } from 'react';

import { Button } from '../Button';
import { Input, InputProps } from '../Input';
import CloseIcon from '../assets/svgs/close.svg';
import SearchIcon from '../assets/svgs/search.svg';
import styles from './search.module.scss';

interface Props extends Omit<InputProps, 'value' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  withClear?: boolean;
  className?: string;
}

export const Search = ({ value, onChange, withClear, className, ...restProps }: Props) => {
  const customOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange?.(e.target.value);
  };

  const isShowClear = withClear && !!value;

  return (
    <Input
      shape='search'
      value={value}
      onChange={customOnChange}
      prefix={<SearchIcon />}
      suffix={
        isShowClear ? (
          <Button shape='circle1' className={styles.clear} onClick={() => onChange?.('')}>
            <CloseIcon />
          </Button>
        ) : undefined
      }
      className={cx(styles.wrapper, className)}
      {...restProps}
    />
  );
};
